<tec-modal
	[isVisible]="true"
	[title]="title"
	[buttonPrimaryLabel]="(copyFeedback() ? 'PANEL.CURL_MODAL.COPIED' : 'PANEL.CURL_MODAL.COPY') | translate"
	(closeEvent)="closeModal($event)">
	<ng-container body>
		<ngx-json-viewer [json]="json"></ngx-json-viewer>
	</ng-container>
</tec-modal>
